import { defineFcm } from '../shared/factory';

export const FCM_PETITION_DISPLAY_RECRUITER_NAME = defineFcm('petition_display_recruiter_name')
	.asBoolean()
	.withDefault(false)
	.toConfig();
